// extracted by mini-css-extract-plugin
export default {"container":"CreateCost_container__EzvPv","label":"CreateCost_label__xFkpC","customInput":"CreateCost_customInput__xraPT"};